module.exports = __webpack_public_path__ + "img/tu1.3dc6134c.png";